export const USER_DOES_NOT_EXIST_MESSAGE =
  'The email you entered is not associated with an account. Please try again.';
export const USER_IS_NOT_ACTIVE_MESSAGE =
  'You are not active in the Member Portal. Please contact your administrator.';

export const LOGIN_PATH = '/login';
